module.exports = __webpack_public_path__ + "static/media/d7kz.2688bed4.pdf";